import React from 'react';

const PensionKlatpensionCalculationInfoDialog = ( { ...props } ) => {
    const { toggleDialog } = props;

    return (
        <div className="modalOverlay" onClick={ toggleDialog }>
            <div className="infoDialog calculationInfoDialog">
                <div>
                    <a onClick={ toggleDialog }>
                        <div></div>
                    </a>
                    <div className="inner">
                        <h4>Forudsætningerne for beregninger af klatpensioner og hvilende ordninger</h4>
                        <p>
                            Bemærk, at vi ikke har adgang til de faktiske omkostninger, som du betaler.
                            Er ordningen via din bank betaler du muligvis ikke faste omkostninger, men der kan være
                            andre høje omkostninger, som gør at ordningen vokser langsomt. Vi anbefaler vi altid,
                            at du taler med en uvildig rådgiver, inden du ændrer noget ved din pension.
                        </p>

                        <ul>
                            <li>Der regnes med en inflationsrate på 1,5 % gennem hele beregningsperioden.</li>
                            <li>Afkast på pension er sat til 5% under opsparing.</li>
                            <li>
                                Alle tal vises i nutidskroner, dvs. de fremtidige udbetalinger bliver nedskrevet med inflationen til den værdi pengene har i
                                dag. Det betyder, at købekraften af det viste beløb om 30 år svarer til det samme som i dag. F.eks. vil en årlig
                                pensionsudbetaling på 46.200 kr. om 30 år vises i nutidsværdi på 30.000 kr. pga. den årlige inflationsrate på 1,5 %.
                            </li>
                            <li>
                                Vi tager udgangspunkt i administrationsomkostninger på 800 kr. om året. Administrationsomkostningerne er et gennemsnit
                                baseret på oplysninger fra de største pensionsselskaber i Danmark. Det kan være et andet beløb for din pension.
                            </li>
                            <li>Tidligere udbetaling end 3 år før folkepensionsalder kræver at ordningen kan blive udbetalt.</li>
                            <li>Den estimerede pensionsalder er folkepensionsalder beregnet ud fra din alder.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

PensionKlatpensionCalculationInfoDialog.defaultProps = {};
PensionKlatpensionCalculationInfoDialog.propTypes = {};
export default PensionKlatpensionCalculationInfoDialog;
